import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import api from '../api/axios';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const navigate = useNavigate();
  const { register, handleSubmit, watch, formState: { errors } } = useForm();
  const [loading, setLoading] = useState(false);
  const password = watch('password');

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password: data.password });
      toast.success('Password reset. Please sign in.');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen aurora stars flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8 relative z-10">
          <Link to="/" className="inline-flex items-center gap-2">
            <img src="/logo-full.png" alt="Holyweds" className="w-36 mx-auto" />
          </Link>
          <h1 className="font-heading text-3xl font-bold text-primary mt-3">Set New Password</h1>
          <p className="text-primary-500 mt-1">Choose a new password for your account</p>
        </div>

        <div className="card p-8 relative z-10">
          {!token ? (
            <div className="text-center py-4">
              <p className="text-4xl mb-3">⚠️</p>
              <p className="font-medium text-gray-800 mb-1">Invalid reset link</p>
              <p className="text-sm text-gray-500 mb-4">This link is missing its reset token. Please request a new one.</p>
              <Link to="/forgot-password" className="text-primary text-sm font-semibold hover:underline">Request new link</Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">New Password</label>
                <input
                  type="password"
                  placeholder="At least 6 characters"
                  className="input-field"
                  {...register('password', {
                    required: 'Password is required',
                    minLength: { value: 6, message: 'Password must be at least 6 characters' }
                  })}
                />
                {errors.password && <p className="text-red-500 text-xs mt-1">{errors.password.message}</p>}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Confirm Password</label>
                <input
                  type="password"
                  placeholder="Re-enter password"
                  className="input-field"
                  {...register('confirmPassword', {
                    required: 'Please confirm your password',
                    validate: (v) => v === password || 'Passwords do not match'
                  })}
                />
                {errors.confirmPassword && <p className="text-red-500 text-xs mt-1">{errors.confirmPassword.message}</p>}
              </div>
              <button type="submit" disabled={loading} className="btn-primary w-full py-3 disabled:opacity-50">
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
            </form>
          )}

          <div className="cross-divider my-6">or</div>
          <Link to="/login" className="block text-center text-primary text-sm font-semibold hover:underline">Back to Sign In</Link>
        </div>
      </div>
    </div>
  );
}
